export function StatusBadge({ status }) {
  const map = { Pending:"badge-amber", Shipped:"badge-blue", Delivered:"badge-green" };
  return <span className={`badge ${map[status] || "badge-gray"}`}>{status}</span>;
}
